import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Images } from "../../../assets";
import Skeleton from "react-loading-skeleton";
import "./arbitratorConcept.css";

const ArbitratorConcept = ({
  conceptDescription,
  conceptHeading,
  conceptImage,
  loader,
}) => {
  return (
    <section className="mediation-concept">
      <Container className="custom-container">
        <Row className="align-items-center justify-content-between">
          <Col lg={7}>
            <div className="content-wrapper mb-lg-0 mb-5">
              <h2 className="mb-3">
                {loader ? <Skeleton width={250} /> : "Overview"}
              </h2>
              {loader ? (
                <Skeleton count={4} height={20} />
              ) : (
                // <div
                //   className="ck-content-wrapper"
                //   dangerouslySetInnerHTML={{
                //     __html:
                //       "",
                //   }}
                // />
                <>
                  <p>
                    The RAKMAC Arbitrator Roster is composed of highly qualified
                    and accomplished professionals from the legal and business
                    communities.
                  </p>
                  <p>
                    Our arbitrators have subject-matter expertise in a
                    particular field and understand the essence of the dispute
                    and the intricacies a given industry brings with it.
                  </p>
                  <p>
                    They also understand the importance of resolving disputes
                    swiftly and efficiently, while preserving due process
                    leading to a fair and just outcome. In addition, they attend
                    ongoing educational events and are committed to honor the
                    RAKMAC Code of Ethics for Arbitrators.
                  </p>
                </>
              )}
            </div>
          </Col>
          <Col lg={4}>
            <div className="img-wrapper">
              {loader ? (
                <Skeleton height={300} />
              ) : (
                <Image
                  src={Images.mediationConcept}
                  alt="section img"
                  loading="lazy"
                  fluid
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ArbitratorConcept;
